export const TOOLTIP_FOR_TWL_SIXTEEN_FIELD = "16' Default Length"

export const TOOLTIP_FOR_T_AND_G_FIELD = 'Tongue and Groove'
